import React, {
  ReactElement,
  ReactNode, 
  RefObject,
} from 'react';
import { SlotKey } from '../utils/types';

export const GridSlot : React.FC<{
  gridKey: SlotKey,
  ref?: RefObject<HTMLDivElement | null>,
  children?: ReactElement,
  className?: string,
  label?: ReactElement,
}> = ({
  gridKey, 
  ref, 
  children, 
  className = "", 
  label, 
  ...props
}) => {
  return (
    <div className={`flex relative`} key={gridKey} ref={ref} >
      <div className={className} {...props}>
        {label}
      </div>
      {children}
    </div>
  )
}